// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"2d7fd9e3","191":"585ea356","339":"5e01ea72","399":"0305910a","592":"db6d747d"}[chunkId] + ".chunk.js";
};